import React from 'react';
import { 
  FaStore, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaClock
} from 'react-icons/fa';

const StoresPage = () => {
  const store = {
    id: 1,
    city: 'Bhabua',
    area: 'Opposite West Gate of Police Station',
    address: 'BRframes, opposite west gate of police station, Bhabua, Bihar 821101',
    phone: '+91 97097 99555',
    hours: '10:00 AM - 9:00 PM',
    landmark: 'Opposite West Gate of Police Station',
    services: ['Home Try-on', 'Eye Test', 'Frame Styling', 'Expert Consultation'],
    mapLink: 'https://www.google.com/maps/search/?api=1&query=BRframes+opposite+west+gate+of+police+station+Bhabua+Bihar+821101'
  };

  // Create embed URL from address (no API key needed with output=embed)
  const mapEmbedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(store.address)}&output=embed`;

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FaStore className="text-5xl mx-auto mb-4 animate-bounce" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Store in Bhabua</h1>
          <p className="text-xl text-orange-100 max-w-2xl mx-auto">
            Visit us for personalized fitting and expert advice
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-500 border border-orange-100">
          <div className="h-3 bg-gradient-to-r from-orange-500 to-orange-600"></div>
          
          <div className="p-8 lg:p-12">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8">
              <div>
                <h2 className="text-4xl font-bold text-gray-800 mb-2">{store.city}</h2>
                <p className="text-xl text-orange-600 font-medium">{store.area}</p>
              </div>
              <div className="mt-4 md:mt-0 bg-orange-100 p-4 rounded-full">
                <FaStore className="text-4xl text-orange-600" />
              </div>
            </div>
            <div className="mb-8 bg-orange-50 p-6 rounded-2xl">
              <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <FaMapMarkerAlt className="text-orange-600" />
                Address
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">{store.address}</p>
              <p className="text-gray-500 mt-2">Landmark: {store.landmark}</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-orange-50 p-6 rounded-2xl">
                <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <FaPhone className="text-orange-600" />
                  Contact
                </h3>
                <a href={`tel:${store.phone.replace(/\s/g, '')}`} className="text-gray-600 text-lg">
                  {store.phone}
                </a>
                <p className="text-sm text-gray-500 mt-1">Call for appointment & availability</p>
              </div>
              <div className="bg-orange-50 p-6 rounded-2xl">
                <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <FaClock className="text-orange-600" />
                  Store Hours
                </h3>
                <p className="text-gray-600 text-lg">{store.hours}</p>
                <p className="text-sm text-gray-500 mt-1">Open all days</p>
              </div>
            </div>
            <div className="mb-10">
              <h3 className="text-lg font-semibold text-gray-700 mb-4">Services Available</h3>
              <div className="flex flex-wrap gap-3">
                {store.services.map((service, i) => (
                  <span key={i} className="bg-orange-100 text-orange-700 px-5 py-2 rounded-full text-sm font-medium shadow-sm">
                    {service}
                  </span>
                ))}
              </div>
            </div>

            {/* Google Maps Embed - Replaces placeholder */}
            <div className="mb-8 rounded-2xl overflow-hidden border-2 border-orange-200 h-80">
              <iframe
                title="Store Location"
                src={mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={store.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 bg-orange-500 text-white py-4 rounded-xl font-semibold hover:bg-orange-600 transition-all duration-300 flex items-center justify-center gap-2 text-lg"
              >
                <FaMapMarkerAlt />
                Get Directions
              </a>

              <a
                href={`tel:${store.phone.replace(/\s/g, '')}`}
                className="flex-1 bg-white border-2 border-orange-500 text-orange-600 py-4 rounded-xl font-semibold hover:bg-orange-50 transition-all duration-300 flex items-center justify-center gap-2 text-lg"
              >
                <FaPhone />
                Call Store
              </a>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center gap-3 mt-8">
          <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.6s' }}></div>
          <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse" style={{ animationDelay: '0.8s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default StoresPage;